var map = {
	"./template.bet575": 1674,
	"./template.bet575.tsx": 1674,
	"./template.bet777": 1675,
	"./template.bet777.tsx": 1675,
	"./template.betbetbet": 1676,
	"./template.betbetbet.tsx": 1676,
	"./template.betstride": 1677,
	"./template.betstride.tsx": 1677,
	"./template.buffalobet": 1678,
	"./template.buffalobet.tsx": 1678,
	"./template.default": 85,
	"./template.default.tsx": 85,
	"./template.epicodds": 1679,
	"./template.epicodds.tsx": 1679,
	"./template.fiestabet": 1680,
	"./template.fiestabet.tsx": 1680,
	"./template.forsport": 1681,
	"./template.forsport.tsx": 1681,
	"./template.gigabet": 1682,
	"./template.gigabet.tsx": 1682,
	"./template.goldenbet888": 1992,
	"./template.goldenbet888.tsx": 1992,
	"./template.goldenrush": 1683,
	"./template.goldenrush.tsx": 1683,
	"./template.hyperbet": 1684,
	"./template.hyperbet.tsx": 1684,
	"./template.juicybet": 1685,
	"./template.juicybet.tsx": 1685,
	"./template.magnumbet": 1686,
	"./template.magnumbet.tsx": 1686,
	"./template.oldgill": 1687,
	"./template.oldgill.tsx": 1687,
	"./template.puntcity": 1688,
	"./template.puntcity.tsx": 1688,
	"./template.pyramidbet": 1689,
	"./template.pyramidbet.tsx": 1689,
	"./template.slambet": 1690,
	"./template.slambet.tsx": 1690,
	"./template.sterlingparker": 1691,
	"./template.sterlingparker.tsx": 1691,
	"./template.sugarcastle": 1692,
	"./template.sugarcastle.tsx": 1692,
	"./template.templebet": 1693,
	"./template.templebet.tsx": 1693,
	"./template.titanbet": 1694,
	"./template.titanbet.tsx": 1694,
	"./template.ts": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;